import React from 'react';

import { VideoPureComponent } from '@bingads-webui-campaign-react/video-pure-component';

import { useControlStyles } from './style';

export const Video = (props) => {
  const classes = useControlStyles();

  return <VideoPureComponent {...props} classes={classes} />;
};
